import { Table, Tbody, Th, Thead, TheadTr } from 'hatch-components';
import React, { useLayoutEffect } from 'react';
import { useConnect } from 'redux-bundler-hook';
import CreateTeamMember from 'root/components/drawers/CreateTeamMember';
import EditTeamMember from 'root/components/drawers/EditTeamMember';
import Card from 'root/components/molecules/Card';
import DefaultTemplate from 'root/components/templates/Default';
import {
  ORGANIZATION_BOARDS,
  ORGANIZATION_TEAM,
} from 'root/stores/fresh/schema';
import { ADD_MEMBER, EDIT_MEMBER } from 'root/stores/routes/APP_URLS';

import TeamEmptyState from './components/TeamEmptyState';
import TeamRow from './components/TeamRow';
import TeamRowSkeleton from './components/TeamRow/skeleton';
import { StyledButton } from './styles';

const Team = () => {
  const {
    doUpdateQuery,
    queryObject: { drawer },
    teamMembersByCurrentOrganizationSortedByDisabledWithoutChatbot: teamMembers,
    teamPageHasErrors,
    teamPageIsLoading,
    numberOfActiveTeamMembersWithoutChatbot: numberOfActiveTeamMembers,
    doSetFreshOrganizationKey,
    currentOrganizationId,
  } = useConnect(
    'doUpdateQuery',
    'selectQueryObject',
    'selectTeamMembersByCurrentOrganizationSortedByDisabledWithoutChatbot',
    'selectTeamPageHasErrors',
    'selectTeamPageIsLoading',
    'selectNumberOfActiveTeamMembersWithoutChatbot',
    'doSetFreshOrganizationKey',
    'selectCurrentOrganizationId',
  );

  // using layout effect to prevent flash
  // TODO: replace with sockets and fresh state
  useLayoutEffect(() => {
    // when route loads, reset organization team key to trigger re-fetch
    doSetFreshOrganizationKey({
      fresh: false,
      key: ORGANIZATION_TEAM,
      organizationIDs: [currentOrganizationId],
    });
    // when route loads, reset organization boards key to trigger re-fetch
    doSetFreshOrganizationKey({
      fresh: false,
      key: ORGANIZATION_BOARDS,
      organizationIDs: [currentOrganizationId],
    });
  }, [doSetFreshOrganizationKey, currentOrganizationId]);

  const getHeaderRight = () => (
    <StyledButton
      data-test-id="f3235c21-02e3-42e7-8406-a8da5b60eaf4"
      onClick={() => doUpdateQuery({ drawer: ADD_MEMBER })}
      variant="stroke"
    >
      + <span>Add Member</span>
    </StyledButton>
  );

  return (
    <DefaultTemplate showErrorState={teamPageHasErrors} title="Team">
      <Card
        headerRight={getHeaderRight}
        title={`Team (${numberOfActiveTeamMembers || 0})`}
      >
        <Table>
          <Thead>
            <TheadTr>
              <Th>Member</Th>
              <Th>Role</Th>
              <Th>Assigned Workspaces</Th>
              <Th>Last Login</Th>
              <Th />
            </TheadTr>
          </Thead>
          <Tbody>
            {teamPageIsLoading ? (
              <>
                <TeamRowSkeleton />
                <TeamRowSkeleton />
                <TeamRowSkeleton />
                <TeamRowSkeleton />
                <TeamRowSkeleton />
                <TeamRowSkeleton />
                <TeamRowSkeleton />
                <TeamRowSkeleton />
                <TeamRowSkeleton />
                <TeamRowSkeleton />
              </>
            ) : null}
            {!teamPageIsLoading && teamMembers.length ? (
              teamMembers.map(
                ({
                  disabled,
                  assignedBoardIDs,
                  email,
                  userId,
                  firstName,
                  lastName,
                  lastActiveAt,
                  role,
                  pending,
                }) => (
                  <TeamRow
                    assignedBoardIDs={assignedBoardIDs}
                    disabled={disabled}
                    email={email}
                    firstName={firstName}
                    id={userId}
                    key={userId}
                    lastActiveAt={lastActiveAt}
                    lastName={lastName}
                    pending={pending}
                    role={role}
                  />
                ),
              )
            ) : (
              <TeamEmptyState
                data-test-id="2b8b7437-00b5-4d32-8c10-a604c0aef796"
                onClick={() => doUpdateQuery({ drawer: ADD_MEMBER })}
              />
            )}
          </Tbody>
        </Table>
      </Card>
      <CreateTeamMember active={drawer === ADD_MEMBER} />
      <EditTeamMember active={drawer === EDIT_MEMBER} />
    </DefaultTemplate>
  );
};

export default Team;
